import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  ListItem,
  ListItemText,
  List,
} from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { useNavigate, useParams } from "react-router";
import imgBanner from "../../assets/img/fav_img.png";
import location from "../../assets/icon/location.png";
import rupees from "../../assets/icon/rupees.png";
import vacancy from "../../assets/icon/people.png";
import img from "../../assets/img/img.png";
import Footer from "../../common/Footer";
// import AllMediaModelApp from "./AllMediaShow";
// import { getAllJob } from "../Jobhiringpost/jobsApi";
// import {
//   applyForJob,
//   getAllJobsMarketplace,
//   getJobProfile,
// } from "./jobListApi";
import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { getAllJob } from "../Jobhiringpost/jobsApi";
import {
  applyForJob,
  getAllJobsMarketplace,
  getJobProfile,
} from "../Jobs/jobListApi";
import AllMediaModelApp from "../Jobs/AllMediaShow";
// import { getAllfranchise } from "../franchise/franchiseApi";
import { getAllfranchise, intrestedApply } from "../franchise/franchiseApi";
import {
  getAllConsultants,
  RequestConsultant,
} from "../myCOnsultant/consultantAPI";
// import { getAllJobsMarketplace } from "./jobListApi";
import FavoriteIcon from "@mui/icons-material/Favorite";

export default function FurnitureDetails() {
  const [job, setJob] = useState(null);
  const { id } = useParams();
  const token = sessionStorage.getItem("smbToken");

  const [hide, setHide] = useState(false);
  const navigate = useNavigate();
  function optionVal(data) {
    if (!data) return "";

    const dataColl = [
      "google",
      "website",
      "instagram",
      "facebook",
      "youTube",
      "pinterest",
      "twitter",
      "linkedIn",
    ];

    const selected = dataColl.filter((key) => data[key]);
    return selected.length ? selected.join(", ") : " ";
  }
  const payload = {
    billerId: 0,
    searchBrandName: "",
  };

  const getData = () => {
    getAllConsultants(payload, (data) => {
      const list = data?.data?.data?.list || [];

      const selected = list.find((item) => String(item?.id) === String(id));

      // console.log("Courses- ", data.data.data.list);
      setJob(selected);
    });
  };

  useEffect(() => {
    getData();
  }, [id]);

  const applyIntrested = () => {
    if (!token) {
      Swal.fire({
        text: "Please Login First",
        icon: "error",
        ...swalAlertPopProps,
      });
      return;
    }

    RequestConsultant({ consultantInformationId: Number(id) }).then((res) => {
      getData();
    });
  };

  // console.log("hhhhooooooo0900000");

  return (
    <>
      <Box sx={{ backgroundColor: "#C0BFFF" }}>
        <Box sx={{ minHeight: "100vh", p: { sm: 1, md: 3, xs: 0 } }}>
          {/* Back Icon */}
          <KeyboardBackspaceIcon
            onClick={() => navigate("/furnitureList")}
            sx={{ fontSize: 30, color: "#01008B", mb: 2, cursor: "pointer" }}
          />

          {/* Job Card */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 3,
              px: { xs: 1.5, sm: 3, md: 10, lg: 20 },
            }}
          >
            {/* topcard */}
            <Grid container spacing={3} alignItems="stretch">
              {/* img */}
              <Grid item xs={12} sm={3}>
                {/* {job?.images?.[0]?.image ? (
                    <Box
                      component="img"
                      src={job.images[0].image}
                      // alt="Preview"
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: 2,
                      }}
                    />
                  ) : (
                    <Box
                      sx={{
                        width: 300,
                        height: 300,
                        borderRadius: 2,
                        backgroundColor: "grey.200",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "grey.500",
                        fontSize: 14,
                      }}
                    >
                      No Image
                    </Box>
                  )} */}

                <Box
                  sx={{
                    height: "100%",
                    minHeight: 250,
                    maxHeight: 320,
                    overflow: "hidden",
                    borderRadius: 3,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                >
                  <Box
                    component="img"
                    src={job?.profileImage}
                    // alt="Preview"
                    sx={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </Box>
              </Grid>

              {/* card */}
              <Grid item xs={12} sm={9} sx={{ display: "flex" }}>
                <Box
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    p: 3,
                    boxShadow: "0px 6px 18px rgba(0,0,0,0.12)",
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  {/* Top section */}
                  <Grid container spacing={3} alignItems="center">
                    {/* Logo */}
                    {/* <Grid item xs={12} sm={3}>
                      <Box
                        component="img"
                        src={job?.logo}
                        sx={{
                          width: "100%",
                          maxWidth: 180,
                          height: 150,
                          objectFit: "cover",
                          borderRadius: 2,
                        }}
                      />
                    </Grid> */}

                    {/* Details */}
                    <Grid item xs={12} sm={12}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              fontSize: { xs: 18, sm: 22, md: 30 },
                              fontWeight: 600,
                              wordBreak: "break-word",
                            }}
                          >
                            {/* {job?.consultantName} */}
                            Abc Furniture
                          </Typography>

                          <Typography
                            sx={{
                              fontSize: { xs: 18, sm: 22, md: 30 },
                              fontWeight: 700,
                            }}
                          >
                            ₹ 20,000
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            gap: 5,
                          }}
                        >
                          <Box
                            component="img"
                            src={imgBanner}
                            sx={{
                              width: "100%",
                              maxWidth: 180,
                              height: 100,
                              objectFit: "cover",
                              borderRadius: 2,
                            }}
                          />
                          <FavoriteIcon
                            sx={{
                              fontSize: 35,
                              color: "#1a1a7a",
                              mb: 0,
                            }}
                          />
                        </Box>
                      </Box>
                      <Typography
                        sx={{
                          fontSize: { xs: 12, sm: 14, md: 16 },
                          fontWeight: 600,
                        }}
                      >
                        Discription
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: { xs: 12, sm: 14, md: 16 },
                          fontWeight: 600,
                          color: "#5F5757",
                        }}
                      >
                        A skilled beauty consultant who provides personalized
                        beauty advice tailored to individual needs. Expert in
                        skincare, haircare, and makeup, with a focus on
                        enhancing natural beauty and boosting confidence.
                      </Typography>
                    </Grid>
                  </Grid>

                  {/* Buttons */}
                  <Grid
                    container
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                    spacing={2}
                  >
                    <Grid item xl={5} lg={6} md={6} sm={6} xs={12}>
                      {" "}
                      <Button
                        fullWidth
                        variant="outlined"
                        onClick={() => setHide(true)}
                        sx={{
                          fontWeight: 600,
                          color: "#01008B",
                          borderRadius: "6px",
                        }}
                      >
                        Social Media Links
                      </Button>
                    </Grid>
                    <Grid item xl={5} lg={6} md={6} sm={6} xs={12}>
                      <Button
                        fullWidth
                        variant="contained"
                        onClick={() => applyIntrested()}
                        sx={{
                          backgroundColor:
                            job?.hasApplied !== true ? "#01008B" : "green",
                          borderRadius: "6px",
                          textTransform: "none",
                          "&:hover": { backgroundColor: "#0201b3" },
                        }}
                      >
                        {job?.hasApplied && (
                          <CheckCircleIcon sx={{ fontSize: 20, mr: 1 }} />
                        )}
                        {/* {job?.hasApplied !== true ? "Apply" : "Applied"} */}
                        Contact us
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>

            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/*City  */}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    Specification :
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.consultantDescription}
                  </Typography>
                  {/* . */}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    Usage Duration :
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.consultantDescription}
                  </Typography>
                  {/* . */}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    The price is negotiable.
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.consultantDescription}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            {/* . */}
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/*City  */}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    Brand Name :
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.consultantDescription}
                  </Typography>
                  {/* . */}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    About The Brand :
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.consultantDescription}
                  </Typography>
                  
                </Grid>
              </Grid>
            </Box>
            {/* .Contact Details  */}
            <Grid container>
              <Grid
                item
                xs={12}
                sx={{
                  background:
                    "linear-gradient(90deg, #21209A 0%, rgba(215, 215, 255, 0) 100%)",
                  padding: "10px 15px",
                  mt: { sm: "10px", xs: "1px" },
                  borderRadius: "5px",
                  color: "#ffff", // optional text color
                  textAlign: "left",
                  // marginBottom: "20px",
                  fontFamily: "'Montserrat', sans-serif",
                  // fontSize: { xs: "14px", sm: "16px", md: "20px" },

                  fontWeight: 500,
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontSize: { xs: "13px", sm: "14px", md: "20px" },
                  }}
                >
                  Contact Details
                </Typography>
              </Grid>
            </Grid>
            <Box
              sx={{
                backgroundColor: "#fff",
                borderRadius: "12px",
                p: 3,
                boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <Grid container>
                <Grid item xs={12}>
                  {/* Mobile Number */}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    Mobile Number
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.mobileNumber1 || "-"}
                  </Typography>

                  {/* Mobile Number */}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    Mobile Number
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.mobileNumber2 || "-"}
                  </Typography>

                  {/* Whatsapp Mobile Number */}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    Whatsapp Mobile Number
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.whatsappNumber || "-"}
                  </Typography>
                  {/* ........... */}
                  {/* Email Id */}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    Email Id
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.emailId1 || "-"}
                  </Typography>

                  {/* Email Id2*/}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    Email Id
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.emailId2 || "-"}
                  </Typography>

                  {/* Address  */}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    Address
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.briefAddress || "-"}
                  </Typography>
                  {/*City  */}
                  <Typography
                    fontWeight={600}
                    fontSize={{ sm: "18px", xs: "16px" }}
                    mb={0.5}
                  >
                    City
                  </Typography>
                  <Typography fontSize="16px" color="#666" mb={2}>
                    {job?.city || "-"}
                  </Typography>
                </Grid>
              </Grid>
            </Box>
            <AllMediaModelApp
              open={hide}
              setOpen={setHide}
              modelData={{
                google: "",
                website: "",
                instagram: "",
                facebook: "",
                youTube: "",
                pinterest: "",
                twitter: "",
                linkedIn: "",
                ...job,
              }}
              // setModalData={setMyBussinessData}
            />
          </Box>
        </Box>
        <Box sx={{ pt: 5 }}>
          <Footer />
        </Box>
      </Box>
    </>
  );
}
